import React, { useEffect, useState } from "react";
import {
    PlusCircleFilled,
    FolderOpenFilled,
    FolderFilled,
    DownOutlined,
    PlusOutlined,
    WarningOutlined,
} from "@ant-design/icons";
import { BiLinkExternal } from "react-icons/bi";
import { Tree, Tag, Skeleton, Tooltip, Menu, Dropdown, Button } from "antd";
import { getMarketPackageCode, getPackage } from "../../../utils/oneintelligence/OneIntelligenceHelper";
import { dynamicSort, folderStyle, getName } from "../../../utils/MainHelper.js";
import RenderComponent from "../../General/RenderComponent";

function BehaviorTree({
    selectedKeyword,
    setselectedKeyword,
    checkedKeys,
    setcheckedKeys,
    treeData,
    isLoading,
    searchedText,
    multiple = true,
    noCloseTag = false,
    setTargetDetails,
}) {
    const [expandedKeys, setexpandedKeys] = useState([]);
    const onClickRemove = (item) => {
        let currentList = [...checkedKeys].filter((i) => i.key !== item.key);
        const childList = item.children || item.tempChildren;
        if (childList) {
            const checkAllRecursive = (items) => {
                items.forEach((child) => {
                    currentList = currentList.filter((i) => i.key !== child.key);
                    const childListSub = child.children || child.tempChildren;
                    if (childListSub && childListSub.length) {
                        checkAllRecursive(childListSub);
                    }
                });
            };
            checkAllRecursive([...childList]);
        }
        setcheckedKeys(currentList);
    };

    useEffect(() => {
        let newList = checkedKeys.sort(dynamicSort("lvl", true));
        const checkAllRecursive = (items) => {
            items.forEach((child) => {
                newList = newList.filter((item) => child.key !== item.parentKey);
                if (child.children && child.children.length) {
                    checkAllRecursive(child.children);
                }
            });
        };
        checkAllRecursive([...newList]);
        setselectedKeyword(newList);
    }, [checkedKeys]);

    const renderElement = (item) => {
        if (item.isElement === "mokb") {
            return (
                <Button
                    type="dashed"
                    icon={<PlusOutlined />}
                    style={{
                        backgroundColor: "#f8fafc",
                        color: "#60A5FA",
                    }}
                    onClick={() => {
                        setTargetDetails(item?.microsegmentDetails || {})
                    }}
                >
                    Add another brand
                </Button>
            );
        }
    };

    const onCheck = (checked, info) => {
        if (!multiple) {
            if (info.checked) {
                setcheckedKeys([info.node]);
            } else {
                setcheckedKeys(checkedKeys.filter((i) => i.key !== info.node.key));
            }
        } else {
            setcheckedKeys(info.checkedNodes);
        }
    };

    const getDomains = ({ url, urls }) => {
        if (!["aitag"].includes(getMarketPackageCode())) return null
        if (!url && !urls) return null;
        const tempUrls = urls?.length ? urls : [url];
        if (tempUrls.length === 1) {
            const [tempLink] = tempUrls;
            return (
                <Tooltip
                    placement="right"
                    title={
                        <span
                            style={{
                                whiteSpace: "nowrap",
                                width: "100%",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                display: "block",
                            }}
                        >
                            {`Goto: ${tempLink}`}
                        </span>
                    }
                >
                    <Button
                        type="link"
                        style={{ padding: "0", height: "6mm" }}
                        onClick={() => {
                            window.open(tempLink, "_blank");
                        }}
                    >
                        <BiLinkExternal style={{ color: "#1890ff", marginLeft: "2mm" }} />
                    </Button>
                </Tooltip>
            );
        }
        const tempStyleObj = {
            padding: "0",
            width: "100%",
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "left",
            lineHeight: "unset",
        };
        const menu = (
            <Menu>
                {tempUrls.map((link) => (
                    <Menu.Item
                        key={link}
                        style={{
                            padding: "1mm 3mm",
                            width: "50mm",
                            overflow: "hidden",
                            display: "block",
                            textOverflow: "ellipsis",
                            textAlign: "left",
                            lineHeight: "unset",
                        }}
                    >
                        <Button
                            type="link"
                            style={{ height: "6mm", ...tempStyleObj }}
                            onClick={() => {
                                window.open(link, "_blank");
                            }}
                        >
                            <span style={tempStyleObj}>{link}</span>
                        </Button>
                    </Menu.Item>
                ))}
            </Menu>
        );
        return (
            <Dropdown menu={menu}>
                <a onClick={(e) => e.preventDefault()}>
                    <BiLinkExternal
                        style={{ color: "#1890ff", marginLeft: "2mm", marginRight: "1mm" }}
                    />
                    <DownOutlined />
                </a>
            </Dropdown>
        );
    };

    const searchedList = searchedText ? [searchedText] : []

    const getContent = () => {
        if (isLoading) {
            return <Skeleton paragraph={{ rows: 6 }} active shape="round" />;
        }
        if (!treeData.length) {
            return (
                <RenderComponent
                    show
                    emptyProps={{
                        description: searchedText ? "No Result Found" : "No Data",
                        style: { marginTop: "5mm" },
                    }}
                />
            );
        }

        return (
            <Tree
                expandedKeys={expandedKeys}
                onCheck={onCheck}
                checkedKeys={checkedKeys.map((checked) => checked.key)}
                onExpand={(e) => {
                    setexpandedKeys(e);
                }}
                titleRender={(item) => {
                    if (item.isElement) return renderElement(item);
                    const { name, children, key, folder, lowActivity } = item;

                    return (
                        <>
                            {(children || folder) && (
                                <>
                                    {expandedKeys.includes(key) ? (
                                        <FolderOpenFilled style={folderStyle} />
                                    ) : (
                                        <FolderFilled style={folderStyle} />
                                    )}
                                </>
                            )}
                            {lowActivity && (
                                <Tooltip title="Low Activity" placement="right">
                                    <WarningOutlined
                                        style={{
                                            color: "#faad14",
                                            fontSize: "3mm",
                                            marginRight: "2mm",
                                        }}
                                    />
                                </Tooltip>
                            )}
                            <span>
                                {getName(name, searchedList)}
                                {getDomains(item)}
                            </span>
                        </>
                    );
                }}
                treeData={treeData}
                checkable
                checkedIcon={<PlusCircleFilled />}
            />
        );
    };

    const getAddedTitle = () => {
        if (!selectedKeyword.length) return null;
        const moduleCode = getPackage();
        // if (moduleCode === "whitespaces") {
        //     return <span><i>Added targets:</i></span>;
        // }
        if (moduleCode === "aitag") {
            return (
                <span>
                    <i>Added sensor:</i>
                </span>
            );
        }
        return (
            <span>
                <i>Added targets:</i>
            </span>
        );
        return <span>Added attributes:</span>;
    };

    return (
        <>
            {getAddedTitle()}
            <div className="tree-item-selected-container">
                {selectedKeyword.map((item) => (
                    <Tag
                        className="oi-tag"
                        key={item.key}
                        icon={
                            <>
                                {item.children || item.folder ? (
                                    <FolderFilled style={{ ...folderStyle, marginRight: 0 }} />
                                ) : (
                                    ""
                                )}
                            </>
                        }
                        closable={!noCloseTag}
                        onClose={() => onClickRemove(item)}
                    >
                        {item.name}
                    </Tag>
                ))}
            </div>
            <div className="tree-container">{getContent()}</div>
        </>
    );
}
export default BehaviorTree;
